import { globalData } from "../..";
import { assetUrl, ID_NAMES } from "../../env";
import params from "../../params";
import { createSoundIcon } from "../messages/sounds";
import playerLinkDiv, { togglePlayerLink } from "./playerLinkDiv";

const createVideo = ({ div, contentDiv }) => {

    let { video } = globalData;
    video = assetUrl(video);
    const { nosnd } = params()

    //VIDEO
    div.classList.add('chatheadMessageWithVideo');

    //PLAYER LINK BOX
    div.append(playerLinkDiv())

    const preload = document.createElement("div");
    preload.classList.add('chatheadPreloadVideo');
    preload.id = ID_NAMES.PRELOAD_VIDEO;

    const animation = document.createElement("div");
    animation.classList.add('chatheadPreloadAnimation');

    const videoDiv = document.createElement("video");
    videoDiv.id = ID_NAMES.VIDEO
    videoDiv.setAttribute('webkit-playsinline', 'webkit-playsinline');
    videoDiv.setAttribute("playsinline", "playsinline")
    videoDiv.setAttribute("preload", "preload")
    videoDiv.autoplay = true;
    videoDiv.src = video;

    if (nosnd) {
        videoDiv.muted = true;
    }

    preload.append(animation)

    contentDiv.append(preload)
    contentDiv.append(videoDiv)

}

//INITIALIZE THE VIDEO WHEN THE CHAT IS OPENED
const videoInit = () => {

    //PROCESS VIDEO IF IT EXISTS
    setTimeout(() => {
        const prealodVideo = document.getElementById(ID_NAMES.PRELOAD_VIDEO)
        const video = document.getElementById(ID_NAMES.VIDEO)

        if (prealodVideo && video) {

            video.after(createSoundIcon())

            //HIDE THE PRELOAD COVER
            prealodVideo.classList.add('hide');

            video.play();
            video.addEventListener("ended", () => {

                togglePlayerLink({ show: true })

            })

        }

    }, 600)
}

export { createVideo, videoInit }